import React from 'react';
import { SignInButton as ClerkSignInButton } from '@clerk/clerk-react';

export const SignInButton: React.FC = () => {
  return (
    <ClerkSignInButton mode="modal">
      <button 
        className="sign-in-btn"
        style={{
          padding: '7px 28px',
          background: 'linear-gradient(135deg, rgba(255,255,255,0.28), rgba(255,255,255,0.1))',
          color: '#f8fafc',
          border: '1px solid rgba(255,255,255,0.35)',
          borderRadius: '12px',
          cursor: 'pointer',
          fontSize: '14px',
          fontWeight: 600,
          backdropFilter: 'blur(12px) saturate(145%)',
          WebkitBackdropFilter: 'blur(12px) saturate(145%)',
          boxShadow: '0 10px 26px rgba(15,23,42,0.28)'
        }}
      >
        Sign In
      </button>
    </ClerkSignInButton>
  );
};
